// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__3FEQA","buttons":"SendReceipts_buttons__1toMY","email":"SendReceipts_email__1QSMT","bookApptTitle":"SendReceipts_bookApptTitle__2E-kR"};